import Result from "@Core/Result";
import { ServiceBase } from "@Core/ServiceBase";
import { IAutomationActionsModel, IAutomationActionStatus } from "@Models/IAutomationDetails";

const API_URL = "/automation/api";
export default class AutomationService extends ServiceBase {
    /**
     * Fetch actions for a given page path
     * @param path
     */
    public async getActions(path: string): Promise<Result<IAutomationActionsModel>> {
        return await this.requestJson({
            url: `${API_URL}/Action?path=${path}`,
            method: "GET",
        });
    }

    /**
     * Execute the action
     * @param actionId
     */
    public async executeAction(actionId: string): Promise<Result<IAutomationActionStatus>> {
        return await this.requestJson({
            url: `${API_URL}/Action/${actionId}/execute`,
            method: "POST",
        });
    }
}
